import { ReactComponent as UserIcon } from "components/icons/usersIcon.svg";

interface IProps {
  count: number;
}

export const UserCount = (props: IProps) => {
  return (
    <div className="Following-Counter">
      <UserIcon />
      {props.count} Users
    </div>
  );
};
